module.exports = [
	{
		"path": "music",
		"name": "Music"
	},
	{
		"path": "music-packs",
		"name": "Music Packs"
	},
	{
		"path": "music-kits",
		"name": "Music Kits"
	},
	{
		"path": "logos-idents",
		"name": "Logos & Idents"
	},
	{
		"path": "sound",
		"name": "Sound Effects"
	},
	{
		"path": "source-files",
		"name": "Source Files"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/categories/audiojungle.json
// module id = 219
// module chunks = 1 2